var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card-collapsable", {
    attrs: {
      headerClass: "cyan darken-1 white--text",
      dialogClass: "auctioneer",
      dialogProp: _vm.dialog,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "visible",
          fn: function () {
            return [
              _c("progress-countdown", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.adminSceglie
                      ? false
                      : _vm.asta_settings.timeout_c,
                    expression:
                      "adminSceglie ? false : asta_settings.timeout_c",
                  },
                ],
                ref: "timer_chooser",
                attrs: {
                  name: "auctioneer",
                  time: _vm.adminSceglie ? 0 : _vm.asta_settings.timeout_c,
                },
                on: { timeover: _vm.timeoverChooser },
              }),
              _vm._v(" "),
              _vm.adminSceglie
                ? _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("groups"),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "title",
          fn: function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.mode_assegna
                      ? "Scegli calciatore da assegnare"
                      : "Scegli calciatore da mettere all'asta"
                  ) +
                  "\n  "
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _c("si-sta-facendo-asta-per"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "svincolati-wrapper" },
                [
                  _c("asta-svincolati", {
                    ref: "asta_svincolati",
                    attrs: {
                      selected: _vm.selectCalciatore,
                      ruoliAllowed: _vm.ruoli_da_chiamare,
                      squadre: _vm.squadre_escluse,
                      maxQuotazione: _vm.maxQuotazione,
                      showInformazioni: "",
                      dialogParent: _vm.dialog,
                      ripple: "",
                    },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        _vm.showPasso
          ? {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "cyan white--text",
                          attrs: { depressed: "", rounded: "" },
                          on: {
                            click: function ($event) {
                              return _vm.passo()
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v("airline_stops"),
                          ]),
                          _vm._v(" Passa\n      "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }